import React from 'react';
import styled from 'styled-components';
import { InfoIcon } from '@abc-intelligence/abc-ui';

import { Tooltip } from 'components';
import { BaseTooltipProps } from 'components/Tooltip/Tooltip';

const InfoMarkIcon = styled(InfoIcon)`
  cursor: pointer;
`;

interface InfoMarkProps extends BaseTooltipProps {
  message: string;
}

const InfoMark: React.FC<InfoMarkProps> = ({
  message,
  direction,
  disable,
  className,
  type,
  textFontSize,
  maxWidth,
}) => {
  if (!message) return null;

  return (
    <Tooltip
      message={message}
      direction={direction || 'right'}
      disable={disable}
      className={className}
      type={type}
      textFontSize={textFontSize}
      maxWidth={maxWidth}
    >
      <InfoMarkIcon />
    </Tooltip>
  );
};

export default InfoMark;
